import axios from 'axios';

import { isCabinet } from '@/constants/base';
import { BASE_URL } from '../constants';

const Axios = axios.create({
  headers: {},
  baseURL: BASE_URL,
});

const initialTokenUrls = [
  '/prod/account-management/primary-account/check',
  '/prod/account-management/otp',
  '/prod/account-management/subscriber/check',
];

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const errorResponse = {
      ...error?.response?.status,
    };
    const isCabinetPage = isCabinet({ currentURL: window.location.href });
    if (
      isCabinetPage &&
      (error.config.url.includes('/accounts') || error.response.status === 401)
    ) {
      try {
        const refreshToken = sessionStorage.getItem('refreshToken');
        const response = await axios.post(
          `${BASE_URL}/prod/account-management/primary-account/refresh-tokens`,
          {},
          {
            headers: {
              'refresh-Token': refreshToken,
            },
          },
        );
        if (response.status === 200) {
          sessionStorage.setItem('accessToken', response.data.accessToken);
          sessionStorage.setItem('refreshToken', response.data.refreshToken);
          return Axios.request(error.config);
        }
      } catch (error) {
        sessionStorage.clear();
        window.location.href = '/login';
      }
    }
    if (error?.response?.status)
      return Promise.reject(error.response.data || errorResponse);
  },
);

Axios.interceptors.request.use((config) => {
  const initialToken = sessionStorage.getItem('initialToken');
  if (initialTokenUrls.some((initialUrl) => config.url.includes(initialUrl))) {
    config.headers['initial-token'] = initialToken;
  }
  config.headers['x-session-id'] = sessionStorage.getItem('sessionId');
  const isCabinetPage = isCabinet({ currentURL: window.location.href });
  const token = sessionStorage.getItem('accessToken');
  if (isCabinetPage && token) {
    config.headers.Authorization = token;
  }

  return config;
});

const cabinetBaseQuery =
  () =>
  async ({ url, method, data, headers, params }) => {
    try {
      const result = await Axios({
        url,
        method,
        data,
        headers,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: { ...axiosError },
      };
    }
  };

export default cabinetBaseQuery;
